import _asyncIterator from "@babel/runtime/helpers/asyncIterator";
import { isEqual, throttle, trimEnd, trimStart } from "lodash-es";
import { delay } from "../../../../lib/utils";
import { getAiPopover } from "../../../../lib/comps/ExprInput/addon/AiPopover";
import { message } from 'ant-design-vue';
const getCodeFromAIRes = res => trimEnd(trimStart(res, '```JavaScript'), '```').replace('/* COMPLETE THIS */', '');
export function installCodeMirrorAiWidget(cm, uicoreAiContext, exprInput) {
  let aiStatus = '';
  let lastCursor = null;
  const getUserInput = line => {
    const userStr = cm.getLine(line);
    const commentIndex = userStr.indexOf('//');
    if (commentIndex < 0) {
      return;
    }
    const comment = userStr.substring(commentIndex + 2).trim();
    return comment;
  };
  const generateAiContext = (field, {
    before,
    comment,
    after
  }) => {
    const descriptionPrompt = field !== null && field !== void 0 && field.description ? `
    your code will be used as ${field.description}
    ` : '';
    const typePrompt = field !== null && field !== void 0 && field.type ? `
     return type is ${field.type} ${field.enum ? `and value must be in enum.value: [${field.enum.map(i => JSON.stringify(i)).join(',')}]` : ''}
     ` : '';
    const titlePrompt = field !== null && field !== void 0 && field.title ? `
     return value will be used as '${field.title}' props for some component
    ` : '';
    const extFields = [];
    const provider = exprInput.finalExprInputCompletionProvider;
    if (provider) {
      var _provider$dataStub;
      // 计算exprInput的fields
      const fields = provider === null || provider === void 0 || (_provider$dataStub = provider.dataStub) === null || _provider$dataStub === void 0 || (_provider$dataStub = _provider$dataStub.call(provider)) === null || _provider$dataStub === void 0 || (_provider$dataStub = _provider$dataStub.schema) === null || _provider$dataStub === void 0 ? void 0 : _provider$dataStub.fields;
      if (Array.isArray(fields)) {
        extFields.push(...fields);
      }
    }
    const context = {
      extSchemaFields: extFields,
      extSystemPrompt: '',
      beforeCode: before,
      userComment: [comment, titlePrompt, typePrompt, descriptionPrompt].map(i => (i === null || i === void 0 ? void 0 : i.trim()) || i).filter(i => i).join('\n'),
      afterCode: after
    };
    return context;
  };
  const startAi = async line => {
    const logger = [];
    window.exprInputAiLogger = logger;
    const {
      ai,
      field
    } = uicoreAiContext();
    const userStr = cm.getLine(line);
    aiStatus = 'running';
    exprInput.aiMaskVisible = true;
    const tempErrorChecker = exprInput.jsErrorChecker;
    exprInput.jsErrorChecker = null;
    let cancel = false;
    const doCancel = () => {
      exprInput.aiMaskVisible = false;
      exprInput.jsErrorChecker = tempErrorChecker;
      aiStatus = '';
    };
    let timeOut;
    const refreshTimeOut = () => {
      clearTimeout(timeOut);
      timeOut = setTimeout(() => {
        doCancel();
        message.error('ai执行超时');
      }, 20e3);
    };
    exprInput.$once('cancelAi', () => {
      cancel = true;
      doCancel();
    });
    const replaceStr = userStr.trimEnd();
    await delay(0);
    cm.operation(() => {
      cm.replaceRange(replaceStr, {
        ch: 0,
        line
      }, {
        ch: Infinity,
        line
      });
      cm.setCursor({
        ch: Infinity,
        line
      });
    });
    const comment = getUserInput(line);
    let strs = '';
    await delay(0);
    const val = cm.getValue();
    const cursor = cm.getCursor();
    const commentCh = cm.getLine(line).indexOf('//');
    const beforeWithoutComment = val.substring(0, cm.indexFromPos({
      ...cursor,
      ch: commentCh
    }));
    const lineEndIndex = cm.indexFromPos({
      ...cursor,
      ch: Infinity
    });
    const before = val.substring(0, lineEndIndex);
    const after = val.substring(lineEndIndex);
    const afterLines = cm.lineCount() - line;
    const context = generateAiContext(field, {
      before: beforeWithoutComment,
      comment,
      after
    });
    let stop;
    logger.push({
      ai,
      context,
      field
    });
    try {
      var _iteratorAbruptCompletion = false;
      var _didIteratorError = false;
      var _iteratorError;
      try {
        for (var _iterator = _asyncIterator(ai(context)), _step; _iteratorAbruptCompletion = !(_step = await _iterator.next()).done; _iteratorAbruptCompletion = false) {
          const resp = _step.value;
          {
            logger.push(resp);
            refreshTimeOut();
            if (resp.stop) {
              stop = resp.stop;
              continue;
            }
            if (resp.error) {
              console.error(resp);
              message.error('ai执行出错 请查看控制台');
              break;
            }
            if (cancel) {
              var _stop;
              (_stop = stop) === null || _stop === void 0 || _stop();
              return;
            }
            if (resp.delta) {
              strs += resp.delta;
              // eslint-disable-next-line no-loop-func
              cm.operation(() => {
                const str = before + getCodeFromAIRes(strs) + after;
                cm.setValue(str);
                cm.scrollIntoView(cm.lineCount() - afterLines);
              });
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (_iteratorAbruptCompletion && _iterator.return != null) {
            await _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } catch (e) {
      console.error('ai error', e);
    } finally {
      clearTimeout(timeOut);
      doCancel();
    }
  };
  const onInput = async (cm, ev) => {
    if (aiStatus === 'running') return;
    lastCursor = cm.getCursor();
    if (!ev.text.some(s => s === '\t')) {
      return;
    }
    const {
      line
    } = ev.from;
    const userStr = cm.getLine(line);
    const commentIndex = userStr.indexOf('//');
    if (commentIndex < 0) {
      return;
    }
    if (!getUserInput(line)) return;
    await startAi(line);
    // 准备ctx的上下文
    //
    // 拼接prompt
    // 定义返回的回调
  };
  cm.on('change', onInput);
  const onInputIdle = throttle(async (cm, ev) => {
    if (!aiStatus) {
      const {
        line
      } = ev.from;
      const cursor = cm.getCursor();
      if (!getUserInput(line)) return;
      if (isEqual(cursor, lastCursor) && cm.getLine(line).indexOf('//') !== -1) {
        // 展示ai浮层
        const {
          element,
          comp
        } = getAiPopover();
        comp.$once('startAi', () => {
          startAi(line);
          // 销毁浮层
          setTimeout(() => {
            comp.$destroy();
            close();
          });
        });
        // 提示 ai
        const markCh = Math.max(cursor.ch + 1, cm.getLine(cursor.line).trimEnd().length + 1);
        const mark = cm.setBookmark({
          ...cursor,
          ch: markCh
        }, {
          widget: element
        });
        const close = () => {
          mark.clear();
          cm.off('beforeChange', close);
          cm.off('cursorActivity', close);
          cm.off('blur', close);
        };
        cm.on('beforeChange', close);
        cm.on('cursorActivity', cm => {
          if (cm.getCursor().line !== cursor.line) {
            close();
          }
        });
      }
    }
  }, 1000, {
    leading: false,
    trailing: true
  });
  cm.on('change', onInputIdle);
  // 极致性能
  if (window.location.search.includes('ai_test=1')) {
    const UICORE_AI_TEST_MODULE = 'wuji:uicoreai';
    const onFocusForAiTest = () => {
      // 抛出去给到xy
      window.AI_TEST_MODULES[UICORE_AI_TEST_MODULE].runAi = async (userInput, extra) => {
        var _userInput$substring$;
        const commentIndex = userInput.indexOf('//');
        const before = userInput.substring(0, commentIndex);
        const comment = (_userInput$substring$ = userInput.substring(commentIndex).split('\n').shift()) === null || _userInput$substring$ === void 0 ? void 0 : _userInput$substring$.substring(2).trim();
        const after = userInput.substring(commentIndex).split('\n');
        // 扔掉注释行
        after.shift();
        const {
          ai,
          field
        } = uicoreAiContext();
        const context = generateAiContext(field, {
          before: before || (extra === null || extra === void 0 ? void 0 : extra.before) || '',
          comment,
          after: after.join('\n') || (extra === null || extra === void 0 ? void 0 : extra.after) || ''
        });
        let res = '';
        var _iteratorAbruptCompletion2 = false;
        var _didIteratorError2 = false;
        var _iteratorError2;
        try {
          for (var _iterator2 = _asyncIterator(ai(context)), _step2; _iteratorAbruptCompletion2 = !(_step2 = await _iterator2.next()).done; _iteratorAbruptCompletion2 = false) {
            const value = _step2.value;
            {
              if (value.error) {
                throw new Error(value.error);
              }
              if (value.delta) {
                res += value.delta;
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (_iteratorAbruptCompletion2 && _iterator2.return != null) {
              await _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
        return getCodeFromAIRes(res);
      };
    };
    cm.on('focus', onFocusForAiTest);
  }
}
//# sourceMappingURL=uicore-expr-input-ai.js.map
